import axios from "axios";

//export const APIURL = "/api/";
  export const APIURL = process.env.REACT_APP_API

const axiosCall = axios.create({
  baseURL: APIURL,
  headers: {
    "Content-type": "application/json",
  },
});

// Add a response interceptor
axiosCall.interceptors.response.use(
  function (response: any) {
    return response;
  },
  function (error: any) {
    return Promise.reject(error);
  }
);

axiosCall.interceptors.request.use(
  async (config) => {
  //  config.withCredentials = true;
    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  }
);

export default axiosCall;
